import { HttpContextToken } from '@angular/common/http';

export const REDIRECT_ON_403 = new HttpContextToken<boolean>(() => false);